import { TabStyles } from '@tableau/widgets';
import { stylesheet } from 'typestyle';

export const ButtonZoneStyle = stylesheet({
  tabButtonObject: {
    textAlign: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
    position: 'relative',
    $nest: {
      '&:focus': {
        outline: 'none',
      },
      '&:focus-visible': {
        outline: `1px solid ${TabStyles.Colors.Focus}`,
        outlineOffset: -1,
      },
    },
  },

  tabButtonZoneDisabledOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    cursor: 'default',
  },
});
